import $ from 'jquery';
window.$ = window.jQuery = $;

import 'vue-slick-carousel';

import 'slick-carousel';
import "slick-carousel/slick/slick.css";

import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

import 'lightgallery';
import 'lightgallery/dist/css/lightgallery.min.css';

import 'axios';

import './tailwind.css';

global.Cookies = require('js-cookie');

window.Lightbox = (function(){
    return{
        init: function(){
            console.log('initalizing Lightbox');
    
            $('.lightbox-js-wrapper').each(function(){
                if ( !$(this).hasClass('lightbox-initialized')){
                    $(this).lightGallery({
                        download: false,
                        selector: '.lightbox-js'
                    });
                    $(this).addClass('lightbox-initialized')
                }
            })
        }
    }
}());

window.initPhoneExt = function(){
	$('.phone-ext-js:visible').each(function(){

		if (! $(this).hasClass('initialized')){

			$(this).addClass('initialized');

			let input = $(this)[0];
			let that = $(this);

			// data-name = input name
			// data-default = default extension

			let name = $(this).data('name')?$(this).data('name'):($(this).attr('name')+"[phone_ext]"); //set input name
			$(this).after('<input type="hidden" class="phone-ext-value" name="'+name+'">');
			let $hiddenInput = $(this).next();

			let initialCountry = 'hk'; //set default
			let defaultcode = $(this).data('default');
			if ( defaultcode ){
				window.intlTelInputGlobals.getCountryData().forEach(function(country){
					if ( country.dialCode==defaultcode){
						initialCountry = country.iso2;
					}
				})
			}

			var iti = intlTelInput(input, {
				autoHideDialCode: false,
				separateDialCode: true,
				initialCountry: initialCountry,
				preferredCountries: ["hk","tw"],
			    // any initialisation options go here
			});
			input.addEventListener("countrychange", function() {
				$hiddenInput.val( iti.getSelectedCountryData().dialCode );
				// console.log(iti.getSelectedCountryData().dialCode);
			});
			$hiddenInput.val( iti.getSelectedCountryData().dialCode );
		}
		
	})
}
window.initPhoneExt();

window.accordion = function(){

	$(".accordion-title").click(function(){

		$(this).toggleClass("active");

		$(this).parent().find(".accordion-body").slideToggle();

	});
}

$(document).on('submit', 'form:not(.form-register)', function(e) {
	e.stopImmediatePropagation();
	e.preventDefault();

	if (!$(this).hasClass('form-auth')) {
		tracking.sendGaEvent('Form submission', 'Form submission', 'Form submission', {
			'event_location': window.location.href
		});
	}

	if ($(this).hasClass('form-login')) {
		tracking.sendGaEvent('Login', 'Login', 'Login', {
			'event_location': window.location.href
		});
	}

	if ($(this).hasClass('form-register')) {
		tracking.sendGaEvent('Registration', 'Registration', 'Registration', {
			'event_location': window.location.href
		});
	}

	if ($(this).hasClass('enquiryForm')) {
		tracking.sendGaEvent('Design enquiry submission', 'Design enquiry submission', 'Design enquiry submission', {
			'event_location': window.location.href
		});
	}

	if ($(this).hasClass('newsletterForm')) {
		tracking.sendGaEvent('Newsletter request submission', 'Newsletter request submission', 'Newsletter request submission', {
			'event_location': window.location.href
		});
	}

	if ($(this).hasClass('contactUsForm')) {
		tracking.sendGaEvent('Contact us form submission', 'Contact us form submission', 'Contact us form submission', {
			'event_location': window.location.href
		});
	}

	e.target.submit();
});

$(document).on('click', '.technical-download', function(e) {
	e.preventDefault();

	tracking.sendGaEvent('Technical download', 'Technical download', 'Technical download: ' + $(this).data('title'), {
		'event_location': window.location.href
	});

	window.open($(this).attr('href'), '_blank');

});